import {
  type NotificationActions,
  NOTIFICATIONS_DELETE,
  NOTIFICATIONS_INTERACT,
  NOTIFICATIONS_LOAD_ERROR,
  NOTIFICATIONS_LOAD_FINISH,
  NOTIFICATIONS_LOAD_START,
  NOTIFICATIONS_MARK_READ,
} from "./actions";
import { notificationsPageInitialState, type NotificationsPageState } from "./types";
import { produce, original } from "immer";

export const notificationsReducer = (
  state = notificationsPageInitialState,
  action: NotificationActions,
): NotificationsPageState => {
  return produce(state, (draft: NotificationsPageState) => {
    switch (action.type) {
      case NOTIFICATIONS_INTERACT: {
        draft.newNotificationAmount = undefined;
        break;
      }

      case NOTIFICATIONS_LOAD_START: {
        draft.isLoading = true;
        draft.isLoaded = false;
        draft.error = false;
        break;
      }

      case NOTIFICATIONS_LOAD_FINISH: {
        const { results, totalAmount } = action.payload;
        draft.data = results;
        draft.totalNumberOfResults = totalAmount;
        draft.isLoading = false;
        draft.isLoaded = true;
        draft.error = false;
        break;
      }

      case NOTIFICATIONS_LOAD_ERROR: {
        draft.isLoading = false;
        draft.isLoaded = false;
        draft.error = true;
        break;
      }

      case NOTIFICATIONS_MARK_READ: {
        const { uids, isRead } = action.payload;
        draft.data.forEach((item) => {
          if (uids.includes(item.uid)) {
            item.read = isRead;
          }
        });
        break;
      }

      case NOTIFICATIONS_DELETE: {
        const uids = action.payload;
        draft.data = original(draft.data)!.filter((item) => !uids.includes(item.uid));
        break;
      }
    }
  });
};
